import React, { useState } from "react";
import CrossIcon from "../../../assets/CloseIcon.svg";
import InformativeIcon from "../../../assets/I icon.svg";
import CustomInputBox from "../../../components/Input";
import RightSideModal from "../.././../components/CustomModal/customRightModal";
import ServiceButton from "../../../components/Button/ServiceButton";
import { toast } from "react-hot-toast";
import { UPDATE_PASSWORD } from "../../../utils/ApiUrls";
import { POST } from "../../../utils/webService";
import EyeIcon from "../../../assets/Login/eye.svg";
import CrossEyeIcon from "../../../assets/Login/crosseye.svg";
import { strongpasswordRegex } from "../../../utils/regexCheck";
import AccessDenied from "../../../components/AccessDenied";
import InfoCircle from "../../../assets/info-circle.svg";
import OneButton from "../../../components/Button/OneButton";
import { checkPageAuthorized } from "../../../redux/reducers/role";


interface PassModalProps {
  isPassModalOpen: boolean;
  setIsPassModalOpen: React.Dispatch<React.SetStateAction<any>>;
  className?: string;
}
interface PasswordVisibility {
  oldPassword: boolean;
  newPassword: boolean;
  confirmNewPassword: boolean;
}

function PassModal(props: PassModalProps) {
  const { isPassModalOpen, setIsPassModalOpen } = props;
  const [password, setPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });

  const [viewPassword, setViewPassword] = useState<PasswordVisibility>({
    oldPassword: false,
    newPassword: false,
    confirmNewPassword: false,
  });

  const [passwordError, setPasswordError] = useState({
    newPassword: "",
    confirmNewPassword: "",
  });

  const updatePassword = async () => {
    if (password?.newPassword !== password?.confirmNewPassword) {
      return toast.error(
        "New password and confirm new password should be same"
      );
    }
    const { data }: any = await POST(UPDATE_PASSWORD, {
      oldPassword: password?.oldPassword,
      newPassword: password?.newPassword,
    });

    if (data?.success) {
      toast.success(data?.message);
      setIsPassModalOpen(false);
    } else {
      toast.error(data?.message);
    }
  };

  const togglePasswordVisibility = (field: keyof PasswordVisibility) => {
    setViewPassword((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  function validatePassword(password: string) {
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+\-=;':"|,.<>/?])([A-Za-z\d!@#$%^&*()_+\-=;':"|,.<>/?]+)$/;
    if (password.length < 8) {
      return "Enter at least 8 characters.";
    }
    if (!passwordRegex.test(password)) {
      if (!/[A-Z]/.test(password)) {
        return "Password must contain at least one uppercase letter.";
      }
      if (!/[!@#$%^&*()_+\-=;':"|,.<>/?]+/.test(password)) {
        return "Password must contain at least one special character.";
      }
      if (!/[0-9]+/.test(password)) {
        return "Password must contain at least one number.";
      }
      if (/\s/.test(password)) {
        return "Password must not contain spaces.";
      }
    }

    if (password.length < 8) {
      return "Enter at least 8 characters.";
    }

    if (password.length > 16) {
      return "Password should be less than 16 characters.";
    }

    return "";
  }
 

   const isActive = checkPageAuthorized("Change Password");


  return (

    <RightSideModal
      isOpen={isPassModalOpen}
      onClose={() => {
        setIsPassModalOpen(false);
      }}
      className="!w-full sm:!w-[440px] md:!w-[500px] lg:!w-[420px] xl:!w-[440px] !max-w-full sm:!max-w-[440px] md:!max-w-[500px] lg:!max-w-[440px]"
      showMobileCancelButton={false}
    >
      {isActive || isActive === undefined ? (
        <div className="flex min-h-full flex-col">
          <div className="flex-1 px-4 pb-6 pt-5 sm:px-5">
            <div className="flex w-full items-center justify-between gap-3">
              <div className="text-[22px] font-normal sm:text-[24px]">
                Change Password
              </div>
              <div className="cursor-pointer">
                <img
                  src={CrossIcon}
                  onClick={() => {
                    setIsPassModalOpen(false);
                    setViewPassword({
                      oldPassword: false,
                      newPassword: false,
                      confirmNewPassword: false,
                    });
                  }}
                  alt="close Icon"
                  width="25px"
                />
              </div>
            </div>
            <div className="mt-5 flex flex-col gap-y-4">
              <CustomInputBox
                label="Old Password"
                maxLength={16}
                inputType={viewPassword.oldPassword ? "text" : "password"}
                isRightIcon={true}
                visibility={viewPassword.oldPassword}
                rightIcon={viewPassword.oldPassword ? EyeIcon : CrossEyeIcon}
                setVisibility={() => togglePasswordVisibility("oldPassword")}
                onClick={() => {}}
                onChange={(e) =>
                  setPassword({ ...password, oldPassword: e.target.value })
                }
              />
              <CustomInputBox
                label="New Password"
                inputType={viewPassword.newPassword ? "text" : "password"}
                isRightIcon={true}
                isInfoIcon={true}
                informativeIcon={InformativeIcon}
                tooltipContent="Password should be 8 to 16 Character with combination of Alpha Numeric and Special Character, One Upper and Lowercase"
                maxLength={16}
                visibility={viewPassword.newPassword}
                rightIcon={viewPassword.newPassword ? EyeIcon : CrossEyeIcon}
                setVisibility={() => togglePasswordVisibility("newPassword")}
                onClick={() => {}}
                onChange={(e) => {
                  setPassword({ ...password, newPassword: e.target.value });
                  if (
                    !strongpasswordRegex.test(e.target.value) ||
                    password.newPassword.length < 8 ||
                    password.newPassword.length > 16
                  ) {
                    const isPasswordError = validatePassword(e.target.value);

                    setPasswordError({
                      ...passwordError,
                      newPassword: isPasswordError,
                    });
                  } else {
                    setPasswordError({
                      ...passwordError,
                      newPassword: "",
                    });
                  }
                }}
              />
              {passwordError.newPassword !== "" && (
                <div className="mt-1 flex items-center gap-x-1">
                  <img src={InfoCircle} alt="" width={10} height={10} />
                  <span className="text-xs font-normal leading-3 text-[#F35838]">
                    {passwordError.newPassword}
                  </span>
                </div>
              )}
              <CustomInputBox
                label="Re-enter New Password"
                inputType={
                  viewPassword.confirmNewPassword ? "text" : "password"
                }
                isRightIcon={true}
                isInfoIcon={true}
                maxLength={16}
                informativeIcon={InformativeIcon}
                tooltipContent="Password should be 8 to 16 Character with combination of Alpha Numeric and Special Character, One Upper and Lowercase"
                visibility={viewPassword.confirmNewPassword}
                rightIcon={
                  viewPassword.confirmNewPassword ? EyeIcon : CrossEyeIcon
                }
                setVisibility={() =>
                  togglePasswordVisibility("confirmNewPassword")
                }
                onClick={() => {}}
                onChange={(e) =>
                  setPassword({
                    ...password,
                    confirmNewPassword: e.target.value,
                  })
                }
              />
            </div>
        </div>
          {/* <div className="sticky bottom-0 mt-auto border-t border-[#E8E8E8] bg-white"> */}
            <footer>
              <div
                style={{ boxShadow: "0px -4px 8px 0px rgba(0, 0, 0, 0.04)" }}
                className="rounded-t-[24px] border border-b-0 border-[#E8E8E8] bg-[#FFFFFF] p-4"
              >
                <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-center sm:gap-4">
                  <OneButton
                    onClick={() => setIsPassModalOpen(false)}
                    text="BACK"
                    className="w-full px-5 sm:w-[96px]"
                    variant="secondary"
                  />
                  <OneButton
                    text="SAVE"
                    className="w-full px-5 sm:w-[96px]"
                    onClick={() => {
                      updatePassword();
                    }}
                    variant="primary"
                  />
                </div>
              </div>
            </footer>
          </div>
        // </div>
      ) : (
        <div>
          <AccessDenied />
        </div>
      )}
    </RightSideModal>
  );
}

export default PassModal;
